import { Divider } from "@nulogy/components";
import styled from "styled-components";

const ThinDivider = styled(Divider)(({ theme, ...props }) => ({
  border: "none",
  borderTop: `1px solid ${theme.colors.lightGrey}`,
  marginBottom: theme.sizes.x1,
  marginTop: theme.sizes.x1,
  ...props,
}));

export default ThinDivider;
